import { Injectable, inject } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators'
import { AppService } from '../services/app.service';
import { AppStateHolder } from './app-state.holder';

@Injectable()
export class CheckPoint {
  private http = inject(HttpClient);
  private _appService = inject(AppService);
  private _appStateHolder = inject(AppStateHolder);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
  }

  canActivate() {
    return this.isAuthenticated();
  }

  isAuthenticated(): any {
    const cookie = this._appStateHolder.getCookie('authType');

    if (!cookie || cookie === 'asp') {
      const authUrl = this._appService.getServerBaseUrl + "/auth";
      return this.http.get(authUrl, { withCredentials: true }).pipe(
        map((response: Response) => {

          let isAuthenticated = response;

          if (isAuthenticated)
            return true;

          location.href = `${authUrl}/login?redirectUrl=${location.href}`;
          return false;
        }))
    }
    else {
      return true;
    }
  }
}
